// Components
import { FormControlLabel, Grid } from "@mui/material";
import CustomSwitch from "../../../../../../components/UI/CustomSwitch";

const ExamCardHeader = ({ label, isActive, onChange }) => {
  return (
    <Grid
      item
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <FormControlLabel
        color={isActive ? "#FFF" : "#5B6D7A"}
        sx={{
          color: isActive ? "#FFF" : "#5B6D7A",
          "& .MuiFormControlLabel-label": {
            fontWeight: "600",
            fontSize: "16px",
            marginLeft: "0px",
          },
        }}
        control={
          <CustomSwitch checked={isActive ?? false} onChange={onChange} />
        }
        label={label}
      />
    </Grid>
  );
};

export default ExamCardHeader;
